<table>
  <thead>
    <tr>
      @for (h of columnHeaders; track trackByIndex($index, h)) {
        <th scope="col" class="personalize-text">{{h?.tableHeader?.text?.resourceValue}}</th>
      }
    </tr>
  </thead>
  <tbody>
    @for (row of rows; track trackByIndex($index, row)) {
      <tr>
        @for (element of row.elements; track element) {
          <ng-template
            visiblewhen
            [layoutObject]="element?.layoutObject"
            [model]="model"
            [specFields]="specFields"
            [isTable]="true"
            >
            @if (element.tableHeader) {
              <th scope="row" class="personalize-text">{{element.tableHeader?.text?.resourceValue}}</th>
            }
            @if (!element.tableHeader) {
              <td [attr.cols]="distributed ? nbrColumns : null">
                @if (element.field) {
                  @if (!element.field.cfgHidden) {
                    <lm-field
                      [layoutObject]="element.field"
                      [layoutInfo]="layoutInfo"
                      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
                      [specFields]="specFields"
                      [placeHolder]="placeHolder"
                      [model]="model"
                      [style.width]="element.width"
                      class="{{element.class}}"
                      (fieldEvent)="onFieldEvent($event)"
                    ></lm-field>
                  }
                }
                @if (element.checkcontrol) {
                  @if (!element.checkcontrol.cfgHidden) {
                    <lm-checkcontrol
                      [layoutObject]="element.checkcontrol"
                      [layoutInfo]="layoutInfo"
                      [specFields]="specFields"
                      [placeHolder]="placeHolder"
                      [model]="model"
                      [style.width]="element.width"
                      class="{{element.class}}"
                      (fieldEvent)="onFieldEvent($event)"
                    ></lm-checkcontrol>
                  }
                }
                @if (element.captchaControl) {
                  <lm-captcha-control [layoutObject]="element.captchaControl"></lm-captcha-control>
                }
                @if (element.header) {
                  <lm-header
                    [layoutObject]="element.header"
                    [layoutInfo]="layoutInfo"
                    [specFields]="specFields"
                    [model]="model"
                    [style.width]="element.width"
                    [previousSiblingIsCollapsible]="element.previousSiblingIsCollapsibleHeader"
                    class="{{element.class}}"
                    (fieldEvent)="onFieldEvent($event)"
                  ></lm-header>
                }
                @if (element.paragraph) {
                  <lm-paragraph
                    [layoutObject]="element.paragraph"
                    [layoutInfo]="layoutInfo"
                    [lmColumnLayoutInfo]="lmColumnLayoutInfo"
                    [specFields]="specFields"
                    [placeHolder]="placeHolder"
                    [model]="model"
                    [style.width]="element.width"
                    class="{{element.class}}"
                    (fieldEvent)="onFieldEvent($event)"
                  ></lm-paragraph>
                }
                @if (element.button) {
                  @if (!element.button.cfgHidden) {
                    <lm-button
                      [layoutObject]="element.button"
                      [layoutInfo]="layoutInfo"
                      [lmColumnLayoutInfo]="lmColumnLayoutInfo"
                      [specFields]="specFields"
                      [model]="model"
                      [style.width]="element.width"
                      class="{{element.class}}"
                      (fieldEvent)="onFieldEvent($event)"
                    ></lm-button>
                  }
                }
                @if (element.Blank) {
                  @if (lmColumnLayoutInfo) {
                    <div
                      lm-blankline
                      class="{{element.class}}"
                    ></div>
                  }
                  @if (!lmColumnLayoutInfo) {
                    <div lm-blankline></div>
                  }
                }
                @if (element.text) {
                  <lm-text
                    [layoutObject]="element.text"
                    [layoutInfo]="layoutInfo"
                    [lmColumnLayoutInfo]="lmColumnLayoutInfo"
                    [specFields]="specFields"
                    [placeHolder]="placeHolder"
                    [model]="model"
                    [style.width]="element.width"
                    class="{{element.class}}"
                    (fieldEvent)="onFieldEvent($event)"
                  ></lm-text>
                }
                @if (element.menu) {
                  <lm-simple-card
                    [automationId]="element.menu.automationId"
                    [type]="element.menu.type"
                    [specFields]="specFields"
                    [model]="model"
                    [scale]="element.menu.menuScale"
                    [link]="element.menu.link"
                    [showBackground]="false"
                    [imageUrl] = "element.menu.image"
                    [title]="element.menu.label"
                    [description]="element.menu.description"
                    [paragraphLayout]="false"
                    [isLink]="element.menu.isLink"
                    [isExternalLink]="element.menu.external"
                    class="{{element.class}} field"
                    (fieldEvent)="onFieldEvent($event)"
                  ></lm-simple-card>
                }
              </td>
            }
          </ng-template>
        }
      </tr>
    }
  </tbody>
</table>
